import moment from 'moment';

import { TDatePickerMode } from '@/common/components/DateComponent/dateComponentMode';
import Constants from '@/common/constants';

export type TDateRangeLimitsConfig = {
  from?: string;
  to?: string;
};

export type TDateFieldLimits = {
  lower: Date;
  upper: Date;
};

export type TDateRangeLimits = {
  from: TDateFieldLimits;
  to: TDateFieldLimits;
};

// Формат парсинга значений/лимитов зависит от режима datepicker.
const DATE_LIMIT_MASK_MAP: Record<TDatePickerMode, string> = {
  date: Constants.DATE_FORMATS['YYYY-MM-DD'],
  yearMonth: Constants.DATE_FORMATS['YYYY-MM-DD'],
  year: Constants.DATE_FORMATS.YYYY,
};

const toLimitDate = (value: string, format: string): Date => moment(value, format).toDate();

/**
 * Рассчитывает перекрёстные лимиты для пары полей диапазона дат:
 * поле «от» не может быть позже выбранного «до», а «до» — раньше выбранного «от».
 * Границы конфигурации (`limits`) и глобальные пределы применяются как внешние ограничения.
 */
export function getDateRangeLimits(params: {
  from?: string | null;
  to?: string | null;
  mode?: TDatePickerMode;
  limits?: TDateRangeLimitsConfig;
}): TDateRangeLimits {
  const { from, to, mode = 'date', limits } = params;
  const format = DATE_LIMIT_MASK_MAP[mode];

  const configLower = limits?.from ? toLimitDate(limits.from, format) : Constants.dateLowerLimit;
  const configUpper = limits?.to ? toLimitDate(limits.to, format) : Constants.dateUpperLimit;
  const fromValue = from ? toLimitDate(from, format) : null;
  const toValue = to ? toLimitDate(to, format) : null;

  return {
    from: { lower: configLower, upper: toValue ?? configUpper },
    to: { lower: fromValue ?? configLower, upper: configUpper },
  };
}
